import React from 'react'

import { FlatPrimaryButton }	from '../../Ui'
import MessageBox				from './MessageBox'
import Icon						from './Icon'

export default function Error({ errorText, buttonText, onClick }) {
	return (
		<div className="l-modal-wrapper">
			<div className="Error">
				<header className="Error__header">
					<Icon className="Error__icon" icon="cancel" />
					<span className="Error__title">Erreur</span>
				</header>
				<div className="Error__content">{errorText}</div>
				<footer className="Error__footer">
					<FlatPrimaryButton onClick={onClick}>{buttonText}</FlatPrimaryButton>
				</footer>
			</div>
		</div>
	)
}



// WEBPACK FOOTER //
// ./src/js/common/components/Error.js